import { useMutation } from '@tanstack/react-query';

import { createSearchModeMessage, type CreateSearchModeMessageRequest } from '../api';

type CreateSearchModeMessageMutationRequest = {
  discoverySessionId: string;
  request: CreateSearchModeMessageRequest;
  signal?: AbortSignal;
};

export function useCreateSearchModeMessage() {
  return useMutation({
    mutationFn: ({ discoverySessionId, request, signal }: CreateSearchModeMessageMutationRequest) =>
      createSearchModeMessage(discoverySessionId, request, signal),
    scope: { id: 'discovery:chat' },
  });
}
